import { render, staticRenderFns } from "./entrevistas.vue?vue&type=template&id=198579f2&scoped=true"
import script from "./entrevistas.vue?vue&type=script&lang=js"
export * from "./entrevistas.vue?vue&type=script&lang=js"
import style0 from "./entrevistas.vue?vue&type=style&index=0&id=198579f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198579f2",
  null
  
)

export default component.exports